const SubsectionTech = {
  Language: [
    "Java",
    "Javascript",
    "TypeScript",
    "Python",
    "C++",
    "Kotlin",
    "C",
    "PHP",
    "C#",
    "Ruby",
    "Rust",
    "GO",
    "Swift",
    "Dart",
    "Objective-C",
    "Perl",
    "R Programming",
    "Ada",
    "Lisp",
    "D Programming",
    "Vala",
    "Crystal",
    "Nim",
    "Lua",
    "SQL",
    "Haskell",
    "Scheme",
    "Erlang",
    "XML",
    "F#",
    "OCaml",
    "Scala",
    "Clojure",
    "Bash",
    "Powershell",
    "TCL",
    "Groovy",
    "Assembly",
    "Julia",
    "MATLAB",
  ].sort(),
  Frontend: [
    "React",
    "Angular",
    "Vue",
    "Svelte",
    "Next",
    "Nuxt",
    "Remix",
    "Preact",
    "Streamlit",
    "Alpine",
    "HTML",
    "WordPress",
    "Zero none (other)",
  ],
  FrontendUI:[
    "Material UI",
    "JoyUI",
    "Tailwind CSS",
    "Shadcn UI",
    "AntDesign",
    "Chakra UI",
    "Mantime",
    "Radix UI",
    "Blueprint UI",
    "React Bootstrap",
    "Semantic UI",
    "Prime React",
    "Headless UI",
    "Motion One",
    "Hyper UI",
    "Daisy UI",
    "Aria Kit",
    "React Aria",
    "Hero UI",
    "Tremor UI",
    "Zero none (other)"
  ].sort(),

  Cybersec: [
    // Core Cybersecurity Concepts
    "Introduction to Cybersecurity",
    "Confidentiality, Integrity, and Availability (CIA Triad)",
    "Authentication and Authorization",
    "Access Control",
    "Risk Management",
    "Threat Modeling",
    "Incident Response",
    "Vulnerability Management",
    "Vulnerability Analysis",
    "Security Policies and Procedures",
    "Information Gathering",
    "Recannaissance (Recon)",
    "Metasploit",

    // Network Security
    "Network Security",
    "Firewalls and IDS/IPS",
    "Virtual Private Networks (VPN)",
    "Secure Network Architecture",
    "Network Segmentation",
    "Zero Trust Architecture",
    "DNS Security",
    "Wi-Fi Security",
    "Port Scanning and Analysis",

    // Cryptography
    "Cryptography",
    "Encryption and Decryption",
    "Symmetric Encryption",
    "Asymmetric Encryption",
    "Public Key Infrastructure (PKI)",
    "Hashing Algorithms",
    "Digital Signatures",
    "SSL/TLS",
    "Quantum Cryptography",

    // Application Security
    "Secure Software Development Lifecycle (SDLC)",
    "Secure Coding Practices",
    "Web Application Security",
    "OWASP Top 10 Vulnerabilities",
    "Static and Dynamic Application Security Testing (SAST/DAST)",
    "API Security",
    "Server-Side Request Forgery (SSRF)",
    "Reverse Engineering",

    // Endpoint and System Security
    "Endpoint and System Security",
    "Endpoint Protection",
    "Patch Management",
    "Antivirus and EDR Solutions",
    "Operating System Hardening",
    "Virtualization Security",
    "Container Security",
    "Device and IoT Security",

    // Identity
    "Identity and Access Management (IAM)",
    "Single Sign-On (SSO)",
    "Multi-Factor Authentication (MFA)",
    "Role-Based Access Control (RBAC)",
    "Privilege Access Management (PAM)",
    "Identity Federation",
    "Biometric Authentication",

    // Data Security
    "Data Security",
    "Data Encryption at Rest and in Transit",
    "Data Loss Prevention (DLP)",
    "Database Security",
    "Cloud Data Security",
    "Data Masking and Tokenization",
    "Backup and Disaster Recovery",

    // Threats and Attacks
    "Threats and Attacks",
    "Malware Analysis",
    "Phishing Attacks",
    "Snoofing and Spoofing Attacks",
    "Trojan Horse",
    "Piggyback",
    "Ransomware",
    "Denial-of-Service (DoS)",
    "Distributed Denial-of-Service (DDoS)",
    "Man-in-the-Middle (MITM) Attacks",
    "SQL Injection",
    "Cross-Site Scripting (XSS)",
    "Social Engineering",
    "Advanced Persistent Threats (APTs)",
    "Wireless Attacks",
    "Evil Twin Attack",
    "Password Attacks",
    "Exploitation Tools",
    "Computer Virus",
    "Post Exploitation",

    // Cybersecurity Tools and Technologies
    "Cybersecurity Tools",
    "SIEM (Security Information and Event Management)",
    "SOAR (Security Orchestration, Automation, and Response)",
    "Penetration Testing Tools (e.g., Metasploit, Burp Suite)",
    "Network Monitoring Tools",
    "Vulnerability Scanners (e.g., Nessus, OpenVAS)",
    "Log Analysis Tools",
    "Forensics Tools",
    "Cloud Security Solutions",

    // Governance, Risk, and Compliance (GRC)
    "Governance, Risk, and Compliance (GRC)",
    "Regulatory Compliance (e.g., GDPR, CCPA, HIPAA)",
    "Security Audits",
    "Cybersecurity Frameworks (e.g., NIST, ISO 27001)",
    "Business Continuity Planning",
    "Third-Party Risk Management",

    // Trends in Cybersecurity
    "Trends in Cybersecurity",
    "AI and ML in Cybersecurity",
    "Zero Trust Security",
    "Quantum-Safe Cryptography",
    "Zero Day Attacks",
    "Bug Bounty",
    "Cyber Threat Intelligence (CTI)",
    "Blockchain Security",
    "Cybersecurity for Cloud Computing",
    "DevSecOps",
    "Cybersecurity for Critical Infrastructure",
    "IoT and OT Security",
    "Post-Quantum Cryptography",

    // Career and Certification Paths
    "Ethical Hacking",
    "Digital Forensics",
    "Cyber Threat Hunting",
    "Security Operations Center (SOC) Analysis",
    "Red Teaming and Blue Teaming",
    "Cybersecurity Certification",
    "Career Path in Cybersecurity",

    // more
    "Dark Web",

    "Zero none (other)",
  ].sort(),
  DataScience: [
    "Introduction to Data Science",
    "Data Science Lifecycle",
    "Data Collection",
    "Data Cleaning and Preprocessing",
    "Exploratory Data Analysis (EDA)",
    "Feature Engineering",
    "Data Wrangling",
    "Data Quality Assessment",
    "Data Ethics",
    "Data Governance",
    
    // Statistical Foundations
    "Descriptive Statistics",
    "Inferential Statistics",
    "Probability Theory",
    "Hypothesis Testing",
    "Bayesian Statistics",
    "Correlation and Causation",
    "Probability Distributions",
    "Statistical Sampling",
    "ANOVA and MANOVA",

    // Data Modeling
    "Predictive Modeling",
    "Regression Analysis",
    "Clustering Analysis",
    "Classification Analysis",
    "Dimensionality Reduction",
    "Time Series Analysis",
    "Anomaly Detection in Data",
    "Optimization Techniques",

    // Data Visualization
    "Extract Transform Load (ETL)",
    "Exploratory Data Analysis (EDA)",
    "Python for Data Science",
    "R for Data Science",
    "Tableau",
    "Power BI",
    "D3.js",
    "Hadoop",
    "Numpy for Data Science",
    "Pandas for Data Science",
    "Apache Spark",
    "SQL for Data Analysis",
    "Excel for Analysis",
    "Data Visualisation",
    "Principles of Data Visualization",
    "Chart Selection and Design",
    "Interactive Dashboards",
    "Storytelling with Data",
    "Zero none (other)",
  ].sort(),
  MachineLearning: [
    "Introduction to ML/AI",
    // Core AI and ML Concepts
    "Artificial Intelligence Overview",
    "Machine Learning Basics",
    "Deep Learning Fundamentals",
    "Natural Language Processing (NLP)",
    "Computer Vision",
    "Robotics",
    "Expert Systems",
    "Cognitive Computing",
    "Fuzzy Logic",
    //  Control functions
    "Relu Activation ",
    "Adam Optimisation",
    "Sochastic Gradient Descent",
    "Sigmoid Activation ",
    "Gradient Descent",
    "Batch Gradient Descent",
    "Mini-Batch Gradient Descent",
    "Activation Functions",

    // Machine Learning Operations (MLOps)
    "Machine Learning Operations (MLOps)",
    "Model Deployment",
    "Monitoring and Logging in ML",
    "Pipeline Automation",

    // more
    "JavaScript for ML/AI",
    "Java for ML/AI",
    "Jax",
    "Hugging Face",
    "Cursor",
    "Sonnet",
    "Loveable",
    "Grok",
    "Chat GPT",
    "Windsurf",
    "Perplexity",
    "llama",
    "Meta AI",
    "Copilot",
    "DeepSeek",
    "Bayes Theorem",
    "Markov Model",
    "Weights and Bias",
    "Feature Extraction",
    "Value Encoding",
    "Model Training",
    "TensorBoard",
    // Types of Machine Learning
    "Supervised Learning",
    "Unsupervised Learning",
    "Reinforcement Learning",
    "Semi-Supervised Learning",

    // Algorithms and Techniques
    "Regression Analysis",
    "Decision Trees",
    "Logistic Regression",
    "Linear Regression",
    "Polynomial Regression",
    "Random Forest",
    "Naive Bayes",
    "XGBoost",
    "Support Vector Machines (SVM)",
    "K-Nearest Neighbors (KNN)",
    "K-Means Clustering",
    "Ensemble Learning",
    "Evolutionary Computation",
    "Swarm Intelligence",
    "Bayesian Networks",

    // Neural Networks and More Core Concepts
    "Neural Networks",
    "FeedForward Neural Networks (FNN)",
    "Convolutional Neural Networks (CNN)",
    "Recurrent Neural Networks (RNN)",
    "Long Short-Term Memory (LSTM)",
    "Gated Recurrent Units (GRU)",
    "Generative Adversarial Networks (GANs)",
    "Variational Autoencoders (VAEs)",
    "Transformers Models",
    "Diffusion Models",
    "Diffusion Transformer Models (DiT)",
    "Large Language Models (LLMs)",
    "Large Language Models Operations (LLMOps)",
    "Encoder-Decoder Networks",
    "Tokenization",
    "N-Grams",

    // Data Processing and Feature Engineering
    "Feature Engineering",
    "Data Cleaning",
    "Dimensionality Reduction",
    "Principal Component Analysis (PCA)",
    "t-SNE",
    "UMAP",
    "Extract Transform Load (ETL)",

    // Tools and Frameworks
    "Python For ML/AI",
    "C++ for ML/AI",
    "TensorFlow",
    "PyTorch",
    "Keras",
    "Scikit-Learn",
    "NLTK",
    "SpaCy",
    "Gensim",
    "Jupyter Notebook",
    "Pandas",
    "Numpy",
    "Seaborn",
    "Matplotlib",
    "Plotly",
    "Bokeh",
    "Holo Views",
    "Intake",

    // Advanced Topics and Applications
    "Transfer Learning",
    "Hyperparameter Tuning",
    "Pre-training",
    "Fine-Tuning",
    "Overfitting Concept",
    "Underfitting Concept",
    "Generative Models",
    "Ethics in AI",
    "Explainable AI (XAI)",
    "Autonomous Systems",

    // Evaluation and Metrics
    "Model Evaluation Metrics",
    "Confusion Matrix",
    "Precision, Recall, F1-Score",
    "ROC-AUC Curve",
    "Cross-Validation",
    "Bias-Variance Tradeoff",
    "Zero none (other)",
  ].sort(),
  Backend: [
    // JavaScript/TypeScript
    "Node",
    "Express",
    "NestJS",
    "Koajs",
    "Fastify",
    "AdonisJS",
    "Hapi.js",
    "Sails.js",
    // Python
    "Django",
    "Flask",
    "FastAPI",
    "Pyramid",
    "Tornado",
    "Bottle",
    // Ruby
    "Ruby on Rails",
    "Sinatra",
    "Hanami",
    // Java
    "Spring Boot",
    "Micronaut",
    "JHipster",
    "Quarkus",
    "Dropwizard",
    // PHP
    "Laravel",
    "Symfony",
    "CodeIgniter",
    "Yii",
    "Phalcon",
    "Slim",
    // C#/.NET
    "ASP.NET",
    "NancyFx",
    "ServiceStack",
    // Go
    "Gin",
    "Echo",
    "Fiber",
    "Beego",
    "Revel",
    // Elixir
    "Phoenix",
    // C++
    "Crow",
    "CppCMS",
    "Drogon",
    // Rust
    "Rocket",
    "Actix",
    "Axum",
    // Perl
    "Dancer",
    "Mojolicious",
    "Catalyst",
    // Scala
    "Play Framework",
    "Akka HTTP",
    // Kotlin
    "Ktor",
    "Javalin",
    // Haskell
    "Yesod",
    "Scotty",
    "Snap",
    "Zero none (other)",
  ].sort(),
  Design: [
    "Figma",
    "Adobe XD",
    "Balsamiq",
    "InVision",
    "Proto.io",
    "UXPin",
    "FlowMap",
    "Framer",
    "Justinmind",
    "Adobe Illustrator",
    "Webflow",
    "Craft",
    "Lucidchart",
    "Adobe Photoshop",
    "Zero none (other)",
  ].sort(),
  DevOps: [
    "Docker",
    "Kubernetes",
    "Jenkins",
    "Terraform",
    "Ansible",
    "Gitlab",
    "Puppet",
    "Travis CI",
    "Bamboo",
    "TeamCity",
    "Argo CI",
    "Spinnaker",
    "Harness DevOps",
    "Buddy",
    "Codefresh",
    "Semaphore",
    "Azure DevOps",
    "Github Actions",
    "BitBucket",
    "BitBucket CodePipeline",
    "AWS CodePipeline",
    "Google Cloud Build",
    "Zero none (other)",
  ].sort(),
  Database: [
    "SQLite",
    "MySQL",
    "IBM DB2",
    "Cockroach DB",
    "MariaDB",
    "VoltDB",
    "YugaByte DB",
    "Timescale DB",
    "PlanetScale DB",
    "PostgreSQL",
    "Amazon DynamoDB",
    "MongoDB",
    "Firebase",
    "Supabase",
    "Neo4j DB",
    "Reddis",
    "CouchDB",
    "Cassandra DB",
    "Microsoft SQL",
    "Amazon DocumentDB",
    "Amazon Aurora",
    "Sybase",
    "TIBCO Visualization",
    "MemSQL",
    "Rethink DB",
    "IBM",
    "Riak DB",
    "Aerospike DB",
    "Oracle Cloudant",
    "Google Bigtable",
    "HyperTable",
    "Amazon Neptune",
    "Orient DB",
    "JanausGraph DB",
    "TigerGraph DB",
    "Cayley DB",
    "Graphite DB",
    "Open TSDB",
    "SAP HANA",
    "Firebird",
    "Percona Server",
    "Google Cloud SQL",
    "Azure Cosmos",
    "Arrango DB",
    "Memgraph",
    "Dgraph DB",
    "PineConeDB",
    "InfluxDB",
    "Dolphine DB",
    "MemCacheDB",
    "KeyDB",
    "Fauna DB",
    "Surreal DB",
    "Hbase DB",
    "Scylla DB",
    "Datasax",
    "Amazon Timestream",
    "Amazon RDS",
    "Apache Ignite",
    "Foundation DB",
    "Apache Drill",
    "TiDB",
    "Elastic Search DB",
    "Apache Solr",
    "Algolia",
    "MeiliSearch DB",
    "Hazelcast DB",
    "Google Spanner",
    "NuoDB",
    "ObjectDB",
    "VersantDB",
    "Zero none (other)",
  ].sort(),
  Android: ["Java", "Kotlin", "JetpackCompose"],
  IOS: ["Objective-C", "Swift"].sort(),
  Cloud: [
    "Amazon Web Services",
    "Microsoft Azure",
    "Google Cloud Platform",
    "Renders",
    "Vercel",
    "Digital Ocean",
    "LightNode",
    "Heroku",
    "Netlify",
    "KenHost",
    "GitHub",
    "Railway",
    "Convex",
    "Superbase",
    "Safaricom",
    "Alibaba",
    "Huawei",
    "Cloudflare",
    "C-Panel",
    "TrueHost",
    "Zero none (other)",
  ].sort(),
  Multiplatform: [
    "Flutter",
    "Kotlin Multiplatform",
    "Xamarin",
    "ReactNative",
    "Electron",
    "Cordova",
    "MAUI",
    "Ionic",
    "Native Script",
    "Capacitor",
    "Framework7",
    "Zero none (other)",
  ].sort(),

  GameDev: [
    "Unity",
    "Unreal Engine",
    "BluePrint",
    "Kotlin",
    "Godot",
    "CryEngine",
    "Amazon Lamberyard",
    "Phaserjs",
    "LibGDx",
    "Java",
    "MonoGame",
    "PyGame",
    "Corona SDK",
    "Defold",
    "SpriteKit",
    "Xamarin",
    "Threejs",
    "C#",
    "C++",
    "Javascript",
    "Babylon",
    "PlayCanvas",
    "CreateJS",
    "MelonJs",
    "AFrame",
    "Vuforia",
    "ARkit",
    "ARCore",
    "Flutter",
    "Zero none (other)",
  ].sort(),
  Containerisation: ["Docker", "Kubernetes", "Helm"].sort(),
  Desktop: [
    "Qt",
    "wxWidgets",
    "Java Swing",
    "JavaFX",
    "Kivy",
    "Tkinter",
    "wxPython",
    "Cocoa",
    "AppKit",
    "GTK",
    "Electron",
    "Flutter",
    "Node-WebKit",
    "Tauri",
    "Delphi",
    "Xamarin",
    "Cocoa Touch",
    "WPF",
    "WinForms",
    "UWP",
    "Avalonia",
  ].sort(),
};

export default SubsectionTech;
